import { extendVariants, Switch as HeroUISwitch } from "@heroui/react";

const ExtendedSwitch = extendVariants(HeroUISwitch, {
  defaultVariants: {
    color: "primary",
    isDisabled: false,
    size: "md",
  },
  variants: {
    color: {
      danger: {
        wrapper: [
          "group-data-[selected=true]:bg-danger",
          "data-[selected=true]:text-danger-foreground",
        ],
      },
      default: {
        wrapper: [
          "group-data-[selected=true]:bg-default-400",
          "group-data-[selected=true]:text-default-foreground",
        ],
      },
      primary: {
        wrapper: [
          "group-data-[selected=true]:bg-primary",
          "group-data-[selected=true]:text-primary-foreground",
        ],
      },
      secondary: {
        wrapper: [
          "group-data-[selected=true]:bg-secondary",
          "group-data-[selected=true]:text-secondary-foreground",
        ],
      },
      success: {
        wrapper: [
          "group-data-[selected=true]:bg-success",
          "group-data-[selected=true]:text-success-foreground",
        ],
      },
      warning: {
        wrapper: [
          "group-data-[selected=true]:bg-warning",
          "group-data-[selected=true]:text-warning-foreground",
        ],
      },
    },
    disableAnimation: {
      false: {
        endContent: [
          "opacity-100",
          "transition-transform-opacity",
          "group-data-[selected=true]:translate-x-3",
          "group-data-[selected=true]:opacity-0",
        ],
        startContent: [
          "opacity-0",
          "scale-50",
          "transition-transform-opacity",
          "group-data-[selected=true]:scale-100",
          "group-data-[selected=true]:opacity-100",
        ],
        thumb: "transition-all",
        wrapper: "transition-background",
      },
      true: {
        thumb: "transition-none",
        wrapper: "transition-none",
      },
    },
    isDisabled: {
      true: {
        base: "opacity-disabled pointer-events-none",
      },
    },
    size: {
      lg: {
        endContent: "text-medium",
        label: "text-large",
        startContent: "text-medium",
        thumb: ["w-6 h-6 text-medium", "group-data-[selected=true]:ms-6"],
        wrapper: "w-14 h-8 me-2",
      },
      md: {
        endContent: "text-small",
        label: "text-small",
        startContent: "text-small",
        thumb: ["w-5 h-5 text-small", "group-data-[selected=true]:ms-5"],
        wrapper: "w-12 h-7 me-2",
      },
      sm: {
        endContent: "text-tiny",
        label: "text-small",
        startContent: "text-tiny",
        thumb: ["w-4 h-4 text-tiny", "group-data-[selected=true]:ms-4"],
        wrapper: "w-10 h-6 me-2",
      },
    },
  },
});

type ExtendedSwitchProps = React.ComponentProps<typeof ExtendedSwitch>;

type Color = Extract<
  ExtendedSwitchProps["color"],
  "primary" | "success" | "warning" | "danger" | "black" | "white"
>;

export type SwitchProps = Omit<ExtendedSwitchProps, "color" | "id"> & {
  color?: Color;
  id: string;
};

export function Switch(props: SwitchProps) {
  return <ExtendedSwitch {...props} />;
}

Switch.displayName = "RecareUI.Switch";
